import React from 'react';
import FloatingIcon from '../General/FloatingIcon'
import './TextContent.scss'; // SASS file for styles

const TextContent = () => {
  return (
    <div className="text-content">
      <h2 className="title">Kind tips</h2>
      <div className="content-section">
        <h3 className="subtitle">[Investment Advice]</h3>
        <p className="text">In order to protect the safety of investors' funds and perform tracking operations to ensure the safety of assets, please pay attention...</p>
      </div>
      <div className="content-section">
        <h3 className="subtitle">[Payment instructions]</h3>
        <p className="text">In order to protect the safety of investors' funds, please follow the official payment method. If there is any...</p>
      </div>
      <div className="content-section">
        <h3 className="subtitle">[Equity incentives]</h3>
        <p className="text">Stock incentive means that after employees with equity incentives meet the conditions, they will be rewarded according to the equity incentive...</p>
        <FloatingIcon/>        
      </div>
    </div>
  );
};

export default TextContent;
